module.exports = __webpack_public_path__ + "public/images/captcha-square-selected.288c140a5a919de8ff6780fcc670803c.svg";